define([
	'jquery',
	'pubsub',
	'wcs.context',
	'Handlebars',
	'handlebars-core',
	'state-manager',
	'promise!wcs.lang-msg'
	], function($, pubsub, context, Handlebars, handlebarsCore, StateManager) {

		'use strict';

		var DEBUG = false,
			PLUGIN_IDENTIFIER = 'minicartMessage';

		var	minicartMessage = function( element, options ) {

			this.pluginID = PLUGIN_IDENTIFIER;

			this.element = element;

			this.$element = $(this.element);

			this.options = options || {};

			this.state = new StateManager();

			this.storeId = context.getStoreId();

			this.mobileCheckoutButtonEnabled = WCS_CONFIG.get("PDP::pdpMobileCTACheckoutEnabled");

			this.mobileShippingButtonEnabled = WCS_CONFIG.get("PDP::pdpMobileCTAShippingEnabled");

			this.mobileApplePayButtonEnabled = WCS_CONFIG.get("applePay::applePayPDPMobileCTAEnabled");

			this.wishlistURL = $(".add-to-wishlist-js").data("wishlist-url");

			this.shopcartURL = $('.btn-shoppingbag-js, .topnav-cart a').attr('href');

			this.shopcartButtonText = WCS_CONFIG.get("PDP::pdpMobileCTAButtonText");

			this.checkoutButtonText = LANG_MSG["MOBILE_SHOP_CART.MSG.successfullyAdded3"];

			this.mobileGenericMessage = WCS_CONFIG.get("global::miniCartMobileGenericMessage");

			return this;
		};


		minicartMessage.prototype = {

			defaults: {

				//Text for Add to Cart, Wishlist, and Remove from Cart/Wishlist
				messages: {
					successAddToCartMessage	: LANG_MSG["MOBILE_SHOP_CART.MSG.successfullyAdded"],
					successAddToCartMessage2 : LANG_MSG["MOBILE_SHOP_CART.MSG.successfullyAdded2"],
					successAddToCartMessage3 : LANG_MSG["MOBILE_SHOP_CART.MSG.successfullyAdded3"],
					successAddToCartMessage4 : LANG_MSG["MOBILE_SHOP_CART.MSG.successfullyAdded4"],

					//Add to Wishlist Messages
					successAddToWishlistMessage : LANG_MSG["MOBILE_WISH_LIST.MSG.successfullyAdded"],
					successAddToWishlistMessage2 : LANG_MSG["MOBILE_WISH_LIST.MSG.successfullyAdded2"],
					successAddToWishlistMessage3 : LANG_MSG["MOBILE_WISH_LIST.MSG.successfullyAdded3"],
					//Remove Item Message (Wishlist and Cart)
					removeFromWishlistMessage : LANG_MSG["DEFAULT_MINICART.MSG.removedFromWishlist"],
					removeFromCartMessage : LANG_MSG["DEFAULT_MINICART.MSG.removedFromShoppingCart"],

					// Close Text for X icon
					closeText: LANG_MSG["MODAL.LABELS.CLOSE"]
				},

				template: "html.mini-cart.messaging",

				//Notification containers where messages go, one for Wishlist and one for Cart
				wishlistPanelNotification: '#wishlist-notification-panel .notification',
				cartPanelNotification: '.global-cart-wishlist-panels-js .notification, .topnav-minicart-panel .notification'
			},

			init: function() {
				var self = this;
				if(DEBUG) console.log('$.fn.minicartMessage init');

				this.config = $.extend( true, {}, this.defaults, this.options, this.metadata );

				this.loadAndCompileTemplate().done(function() {
					self.events();
				});

				return this;
			},

			events: function() {
				if(DEBUG) console.log('minicartMessage events added');

				var self = this;

				$.pubsub('subscribe', 'ORDER_ID_UPDATED', function(message, data) {
					self.state.setProperty({'orderId': data.orderId});
				});

				//Listen for Add to Cart
				$.pubsub('subscribe', 'SHOPCART_UPDATED.add', function(msg, data) {
					// A product was successfully added to the shopping cart
					if(DEBUG) console.log('minicartMessage event - shopcart item added to cart', data);

					data = data || {};

					//Set container for message
					self.$element = $(self.config.cartPanelNotification);
					self.checkoutURL = "VFShippingAddressView?orderId="+self.state.getProperty("orderId")+"&storeId="+self.storeId;
					self.cartItemCount = context.getShoppingCart().quantity;

					//Set Properties needed for message template
					self.state
						.setProperty({'productName': data.product[0].name})
						.setProperty({'shopcart' : true})
						.setProperty({'genericMessageEnabled': self.mobileGenericMessage})
						.setProperty({'shopcartURL': self.shopcartURL})
						.setProperty({'checkoutURL': self.checkoutURL})
						.setProperty({'cartItemCount': self.cartItemCount})
						.setProperty({'shopcartButtonText': self.shopcartButtonText})
						.setProperty({'checkoutButtonText': self.checkoutButtonText})
						.setProperty({'mobileShippingButtonEnabled': self.mobileShippingButtonEnabled})
						.setProperty({'mobileCheckoutButtonEnabled': self.mobileCheckoutButtonEnabled})
						.setProperty({'mobileApplePayButtonEnabled': self.mobileApplePayButtonEnabled});

					//Render Message
					if(!data.disableMiniCart) self.render();
				});

				//Listen for removal of item from Shopcart
				$.pubsub('subscribe', 'SHOPCART_UPDATED.remove', function(msg, data) {
					// A product was successfully removed from the shopping cart
					if(DEBUG) console.log('minicartMessage event - shopcart item removed from cart');

					//Set container for message
					self.$element = $(self.config.cartPanelNotification);

					//Set Properties needed for message template
					self.state
						.setProperty({'message': self.config.messages.removeFromCartMessage})
						.setProperty({ 'removeItem': true });

					//Render Message
					self.render();

				});

				//Listen for removal of item from Wishlist
				$.pubsub('subscribe', 'WISHLIST_UPDATED.remove', function(msg, data) {
					// A product was successfully removed from Wishlist
					if(DEBUG) console.log('minicartMessage event - wishlist item removed from cart', data.product[0]);

					// Check for showMiniCartMsg value to ensure we don't display cart item removed messsage when
					// wishlist item is added to cart.
					var showMsg = true;
					if (data.product && data.product.length && data.product[0].showMiniCartMsg !== undefined && data.product[0].showMiniCartMsg === false) {
						showMsg = false;
					}

					if (showMsg) {
						//Set container for message
						self.$element = $(self.config.cartPanelNotification);

						//Set Properties needed for message template
						self.state
							.setProperty({'message': self.config.messages.removeFromWishlistMessage})
							.setProperty({ 'removeItem': true });

						//Render Message
						self.render();
					}

				});

				$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_wishlist_succeeded', function(msg, data) {
					// A product was successfully added to the wishlist
					if(DEBUG) console.log('minicartMessage event - item added to wishlist');

					//Set container for message
					self.$element = $(self.config.wishlistPanelNotification);

					//Set Properties needed for message template
					self.state
						.setProperty({'wishlist' : true})
						.setProperty({'productName': data.productName})
						.setProperty({'wishlistURL': self.wishlistURL});

					//Render Message
					self.render();

				});
			},

			// overwriting core render
			render : function () {

				if ( DEBUG ) console.log( 'minicartMessage render' );

				//Set Properties needed for message template
				this.state.setProperty({'config' : this.config});

				//Generate and Add Message to Container
				this.$element.html( this.compiledTemplate( this.state.getState() ) );

				//Clear State after message generated and added
				this.state.clearState();

				return this;
			}

		};

		minicartMessage.defaults = minicartMessage.prototype.defaults;

		minicartMessage.prototype = $.extend({}, handlebarsCore, minicartMessage.prototype);

		// prevent duplicate instantiation
		$.fn.minicartMessage = function(options) {
			return this.each(function() {
				var instance = $(this).data(PLUGIN_IDENTIFIER);
				if(!instance) {
					instance = new minicartMessage(this, options).init();
					$(this).data(PLUGIN_IDENTIFIER,instance);
				}
			});
		};
	}
);